export default __webpack_public_path__ + "assets/icon-arrow-drop-bg.aa1057a8.webp";